/**
 * Chutt... - ChartTooltip
 * Custom Recharts tooltip with dark theme (Meltwater-inspired)
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../styles/colors';

function ChartTooltip({ active, payload, label, valueFormatter }) {
  if (!active || !payload?.length) return null;

  return (
    <Box sx={{
      bgcolor: colors.charcoal,
      color: colors.white,
      px: 1.5,
      py: 1,
      borderRadius: 1.5,
      boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
      fontSize: '0.8rem',
      minWidth: 120,
    }}>
      {label && (
        <Typography sx={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.6)', mb: 0.5 }}>
          {label}
        </Typography>
      )}
      {payload.map((entry, idx) => (
        <Box key={idx} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: entry.color }} />
            <span>{entry.name}</span>
          </Box>
          <Typography sx={{ fontWeight: 600 }}>
            {valueFormatter ? valueFormatter(entry.value) : entry.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default ChartTooltip;
